export function resolveNestLayout({
  surface,
  seasonStatus,
  hasSeasonTitle,
}: {
  surface: 'season' | 'lifetime' | 'leaderboard';
  seasonStatus?: string | null;
  hasSeasonTitle?: boolean;
}): {
  leadingFamilyId: 'season' | 'views';
  labeledFamilyId: 'season' | 'views' | null;
} {
  if (surface === 'season') {
    const labeled =
      seasonStatus === 'consolidated' && hasSeasonTitle ? 'season' : null;
    return { leadingFamilyId: 'season', labeledFamilyId: labeled };
  }
  if (surface === 'lifetime') {
    return { leadingFamilyId: 'views', labeledFamilyId: 'views' };
  }
  return { leadingFamilyId: 'views', labeledFamilyId: null };
}
